import React from 'react';
import { UserPlusIcon, UsersIcon, AlertTriangleIcon, ClockIcon, CheckCircleIcon, FileTextIcon, CreditCardIcon } from 'lucide-react';
export function VendorDashboard({
  vendors,
  setCurrentView,
  locale = 'en-US'
}) {
  // Calculate summary statistics
  const totalVendors = vendors.length;
  const activeVendors = vendors.filter(vendor => vendor.vendorStatus?.name === 'Active').length;
  const pendingOnboarding = vendors.filter(vendor => vendor.vendorStatus?.name === 'Pending Onboarding' || vendor.vendorStatus?.name === 'Invited').length;
  // Check for compliance issues
  const complianceIssues = vendors.filter(vendor => !vendor.isCompliant).length;
  // Get recent vendors (sorted by creation date)
  const recentVendors = [...vendors].sort((a, b) => new Date(b.createdUtc).getTime() - new Date(a.createdUtc).getTime()).slice(0, 5);
  // Get vendors with compliance issues
  const vendorsWithIssues = vendors.filter(vendor => !vendor.isCompliant || vendor.complianceIssues.length > 0).slice(0, 5);
  // Navigate to vendor list with status filter
  const handleViewVendorsByStatus = status => {
    // Store the filter preference (in a real app, this would be passed as a prop or through state management)
    sessionStorage.setItem('vendorStatusFilter', status);
    setCurrentView('vendors');
  };
  return <div data-id="element-21800">
      <div className="mb-8 flex justify-between items-center" data-id="element-21801">
        <div data-id="element-21802">
          <h3 className="text-xl font-semibold text-gray-900" data-id="element-21803">
            Vendor Dashboard
          </h3>
          <p className="mt-1 text-sm text-gray-500" data-id="element-21804">
            Overview of your vendor network and compliance status
          </p>
        </div>
        <div className="flex space-x-3" data-id="element-21805">
          <button onClick={() => setCurrentView('onboard-vendor')} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-21806">
            <UserPlusIcon className="h-4 w-4 mr-1" data-id="element-21807" />
            Add New Vendor
          </button>
          <button onClick={() => setCurrentView('vendors')} className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-21808">
            <UsersIcon className="h-4 w-4 mr-1" data-id="element-21809" />
            View All Vendors
          </button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 mb-8" data-id="element-21810">
        <button onClick={() => setCurrentView('vendors')} className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow text-left" data-id="element-21811">
          <div className="p-5" data-id="element-21812">
            <div className="flex items-center" data-id="element-21813">
              <div className="flex-shrink-0" data-id="element-21814">
                <UsersIcon className="h-6 w-6 text-gray-400" data-id="element-21815" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-21816">
                <dl data-id="element-21817">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-21818">
                    Total Vendors
                  </dt>
                  <dd data-id="element-21819">
                    <div className="text-lg font-medium text-gray-900" data-id="element-21820">
                      {totalVendors}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </button>

        <button onClick={() => handleViewVendorsByStatus('Active')} className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow text-left" data-id="element-21821">
          <div className="p-5" data-id="element-21822">
            <div className="flex items-center" data-id="element-21823">
              <div className="flex-shrink-0" data-id="element-21824">
                <CheckCircleIcon className="h-6 w-6 text-green-400" data-id="element-21825" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-21826">
                <dl data-id="element-21827">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-21828">
                    Active Vendors
                  </dt>
                  <dd data-id="element-21829">
                    <div className="text-lg font-medium text-gray-900" data-id="element-21830">
                      {activeVendors}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </button>

        <button onClick={() => handleViewVendorsByStatus('Pending Onboarding')} className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow text-left" data-id="element-21831">
          <div className="p-5" data-id="element-21832">
            <div className="flex items-center" data-id="element-21833">
              <div className="flex-shrink-0" data-id="element-21834">
                <ClockIcon className="h-6 w-6 text-blue-400" data-id="element-21835" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-21836">
                <dl data-id="element-21837">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-21838">
                    Pending Onboarding
                  </dt>
                  <dd data-id="element-21839">
                    <div className="text-lg font-medium text-gray-900" data-id="element-21840">
                      {pendingOnboarding}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </button>

        <button onClick={() => setCurrentView('vendors')} className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow text-left" data-id="element-21841">
          <div className="p-5" data-id="element-21842">
            <div className="flex items-center" data-id="element-21843">
              <div className="flex-shrink-0" data-id="element-21844">
                <AlertTriangleIcon className="h-6 w-6 text-yellow-400" data-id="element-21845" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-21846">
                <dl data-id="element-21847">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-21848">
                    Compliance Issues
                  </dt>
                  <dd data-id="element-21849">
                    <div className="text-lg font-medium text-gray-900" data-id="element-21850">
                      {complianceIssues}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </button>
      </div>

      {/* Recent Vendors and Compliance Issues */}
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2" data-id="element-21851">
        <div className="bg-white shadow overflow-hidden sm:rounded-md mb-8" data-id="element-21852">
          <div className="px-4 py-5 border-b border-gray-200 sm:px-6 flex justify-between items-center" data-id="element-21853">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-21854">
              Recently Updated Vendors
            </h3>
            <button onClick={() => setCurrentView('vendors')} className="text-sm text-indigo-600 hover:text-indigo-900" data-id="element-21855">
              View all
            </button>
          </div>
          <ul className="divide-y divide-gray-200" data-id="element-21856">
            {recentVendors.length === 0 ? <li className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-21857">
                No vendors found.
              </li> : recentVendors.map(vendor => <li key={vendor.vendorId} className="px-4 py-4 sm:px-6 hover:bg-gray-50 cursor-pointer" onClick={() => setCurrentView('vendors')} data-id="element-21858">
                  <div className="flex items-center justify-between" data-id="element-21859">
                    <div className="flex items-center" data-id="element-21860">
                      <div className="flex-shrink-0" data-id="element-21861">
                        <UsersIcon className="h-5 w-5 text-gray-400" data-id="element-21862" />
                      </div>
                      <p className="ml-2 text-sm font-medium text-indigo-600 truncate" data-id="element-21863">
                        {vendor.vendorName}
                      </p>
                    </div>
                    <div className="ml-2 flex-shrink-0" data-id="element-21864">
                      {getStatusBadge(vendor.vendorStatus?.name)}
                    </div>
                  </div>
                  <div className="mt-2 sm:flex sm:justify-between" data-id="element-21865">
                    <div className="sm:flex" data-id="element-21866">
                      <p className="flex items-center text-sm text-gray-500" data-id="element-21867">
                        {vendor.type} • {vendor.country}
                      </p>
                    </div>
                    <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0" data-id="element-21868">
                      <p data-id="element-21869">
                        Last updated:{' '}
                        <span className="ml-1.5" data-id="element-21870">
                          {new Date(vendor.createdUtc).toLocaleDateString(locale)}
                        </span>
                      </p>
                    </div>
                  </div>
                </li>)}
          </ul>
        </div>

        <div className="bg-white shadow overflow-hidden sm:rounded-md mb-8" data-id="element-21871">
          <div className="px-4 py-5 border-b border-gray-200 sm:px-6 flex justify-between items-center" data-id="element-21872">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-21873">
              Compliance Issues
            </h3>
            <button onClick={() => setCurrentView('vendors')} className="text-sm text-indigo-600 hover:text-indigo-900" data-id="element-21874">
              View all
            </button>
          </div>
          <ul className="divide-y divide-gray-200" data-id="element-21875">
            {vendorsWithIssues.length === 0 ? <li className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-21876">
                No compliance issues found.
              </li> : vendorsWithIssues.map(vendor => <li key={vendor.vendorId} className="px-4 py-4 sm:px-6 hover:bg-gray-50 cursor-pointer" onClick={() => setCurrentView('vendors')} data-id="element-21877">
                  <div className="flex items-center justify-between" data-id="element-21878">
                    <div className="flex items-center" data-id="element-21879">
                      <div className="flex-shrink-0" data-id="element-21880">
                        <AlertTriangleIcon className="h-5 w-5 text-yellow-400" data-id="element-21881" />
                      </div>
                      <p className="ml-2 text-sm font-medium text-indigo-600 truncate" data-id="element-21882">
                        {vendor.vendorName}
                      </p>
                    </div>
                    <div className="ml-2 flex-shrink-0" data-id="element-21883">
                      {vendor.isCompliant ? <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-21884">
                          <CheckCircleIcon className="mr-1 h-3 w-3" data-id="element-21885" />
                          Compliant
                        </span> : <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-21886">
                          <AlertTriangleIcon className="mr-1 h-3 w-3" data-id="element-21887" />
                          Non-Compliant
                        </span>}
                    </div>
                  </div>
                  <div className="mt-2 sm:flex sm:justify-between" data-id="element-21888">
                    <div className="sm:flex" data-id="element-21889">
                      <p className="flex items-center text-sm text-gray-500" data-id="element-21890">
                        {getComplianceIssue(vendor)}
                      </p>
                    </div>
                    <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0" data-id="element-21891">
                      <p data-id="element-21892">
                        <button className="text-indigo-600 hover:text-indigo-900" onClick={e => {
                    e.stopPropagation();
                    setCurrentView('vendors');
                  }} data-id="element-21893">
                          Review
                        </button>
                      </p>
                    </div>
                  </div>
                </li>)}
          </ul>
        </div>
      </div>
    </div>;
}
// Helper function to render status badges
function getStatusBadge(status) {
  switch (status) {
    case 'Active':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-21894">
          <CheckCircleIcon className="mr-1 h-3 w-3" data-id="element-21895" />
          {status}
        </span>;
    case 'Pending Onboarding':
    case 'Invited':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-21896">
          <ClockIcon className="mr-1 h-3 w-3" data-id="element-21897" />
          {status}
        </span>;
    case 'Inactive':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-21898">
          <UsersIcon className="mr-1 h-3 w-3" data-id="element-21899" />
          {status}
        </span>;
    default:
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-21900">
          {status}
        </span>;
  }
}
function getComplianceIssue(vendor) {
  if (vendor.complianceIssues.length === 0) {
    return 'No specific issues';
  }
  const issue = vendor.complianceIssues[0];
  return issue.notes || issue.complianceIssueType.name;
}